import classNames from 'classnames';
import React from 'react';
import './Label.scss';
import ILabelProps from './LabelProps';

const Label = ({ required, optional, className, children, secondaryLabel }: ILabelProps) => {
  let subLabel = '';

  if (required) {
    subLabel = 'Required';
  } else if (optional) {
    subLabel = 'Optional';
  }

  return (
    <label className={classNames('label', className)}>
      {children}
      {(subLabel || secondaryLabel) && (
        <span className="secondary-label">
          {' '}
          - {subLabel} {secondaryLabel}
        </span>
      )}
    </label>
  );
};

export default Label;
